module.exports = __webpack_public_path__ + "static/media/logo-trackage-vertical.83c4f196.svg";